<template>
  <van-cell :title="item.title" :border="item.border">
    <!-- 使用 title 插槽来自定义标题 -->
    <!-- <template #title>
      <span class="custom-title">单元格</span>
      <van-tag type="danger">标签</van-tag>
    </template> -->
    <!-- 使用 right-icon 插槽来自定义右侧图标 -->
    <template #right-icon>
      <svg-icon :icon-class="item.icon || 'icon_arrow_rig_gray'"></svg-icon>
    </template>
  </van-cell>
</template>

<script>
import { Cell } from 'vant'
export default {
  name: 'BaseCell',
  components: {
    [Cell.name]: Cell
  },
  props: {
    item: {
      type: Object
    }
  }
}
</script>

<style lang="less" scoped>
.svg-icon {
  width: 32px;
  height: 32px;
}
</style>
